export default "__VITE_ASSET__9c2acfdb__"